jQuery(document).ready(function ($) {
    function toggleLoadingScreen() {
        $('.loading').fadeToggle(250);
    }
});